import { render, staticRenderFns } from "./DButton.vue?vue&type=template&id=ccd81936&"
import script from "./DButton.vue?vue&type=script&lang=js&"
export * from "./DButton.vue?vue&type=script&lang=js&"
import style0 from "./DButton.vue?vue&type=style&index=0&id=ccd81936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports